import { render } from "./CommunityNumberField.vue?vue&type=template&id=66d4a887"
import script from "./CommunityNumberField.vue?vue&type=script&lang=js"
export * from "./CommunityNumberField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__